"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _grupoZap = _interopRequireDefault(require("../../../../themes/grupo-zap"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var colors = _grupoZap["default"].colors,
  util = _grupoZap["default"].util,
  style = _grupoZap["default"].style,
  sizes = _grupoZap["default"].sizes;
var sizeAdapter = util.sizeAdapter;
var border = style.border;
var theme = {
  actionMedium: {
    border: border({
      width: 0
    }),
    borderRadius: sizes.radiusXs,
    textTransform: 'uppercase',
    bg: colors.successLight,
    hoverBg: colors.successMedium,
    fontColor: colors.white,
    fontSize: sizeAdapter(16),
    height: sizeAdapter(40),
    verticalPadding: sizeAdapter(10),
    horizontalPadding: sizeAdapter(24)
  },
  neutralMedium: {
    border: border({
      color: colors.orange
    }),
    borderRadius: sizes.radiusPill,
    textTransform: 'none',
    bg: colors.white,
    hoverBg: colors.orange,
    hoverColor: colors.white,
    fontColor: colors.orange,
    fontSize: sizeAdapter(16),
    height: sizeAdapter(40),
    verticalPadding: sizeAdapter(10),
    horizontalPadding: sizeAdapter(15)
  },
  actionSmall: {
    border: border({
      width: 0
    }),
    borderRadius: sizes.radiusPill,
    textTransform: 'none',
    bg: colors.orange,
    hoverBg: colors.orangeDark,
    fontColor: colors.white,
    fontSize: sizeAdapter(16),
    height: sizeAdapter(32),
    verticalPadding: sizeAdapter(10),
    horizontalPadding: sizeAdapter(15)
  },
  normalSmall: {
    border: border({
      color: colors.secondaryMedium
    }),
    borderRadius: sizes.radiusPill,
    textTransform: 'none',
    bg: colors.white,
    hoverBg: colors.secondaryMedium,
    hoverColor: colors.white,
    fontColor: colors.secondaryMedium,
    fontSize: sizeAdapter(14),
    height: sizeAdapter(32),
    verticalPadding: sizeAdapter(0),
    horizontalPadding: sizeAdapter(16)
  },
  cancelMedium: {
    border: border({
      width: 0
    }),
    borderRadius: sizes.radiusPill,
    textTransform: 'uppercase',
    bg: colors.white,
    hoverBg: colors.white,
    fontColor: colors.successLight,
    fontSize: sizeAdapter(16),
    height: sizeAdapter(40),
    verticalPadding: sizeAdapter(10),
    horizontalPadding: sizeAdapter(15)
  },
  payNowSmall: {
    border: border({
      color: colors.white
    }),
    borderRadius: sizes.radiusPill,
    textTransform: 'none',
    bg: colors.orange,
    hoverBg: colors.orange,
    hoverColor: colors.white,
    fontColor: colors.white,
    fontSize: sizeAdapter(14),
    height: sizeAdapter(32),
    verticalPadding: sizeAdapter(0),
    horizontalPadding: sizeAdapter(16)
  }
};
var _default = exports["default"] = theme;